import {
  takeLatest,
  put,
  putResolve,
  select,
} from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import { actionLoadCreatePreparationRequest } from '../../siteBuilder/actions/loadCreatePreparation';

import { maybeHandleCriticalErrorWithHistory } from 'react-redux-app/lib/modules/api/utils';

import { ACTION_DELETE_SITE__SUCCESS } from '../actionTypes';

import { getLoadCreatePreparationError } from '../../siteBuilder/selectors/errors';


function* reloadCreatePreparation(history) {
  try {
    yield putResolve(actionLoadCreatePreparationRequest());

    const error = yield select(getLoadCreatePreparationError);
    maybeHandleCriticalErrorWithHistory(history, error?.globalErrors);
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga(history) {
  yield takeLatest([ACTION_DELETE_SITE__SUCCESS], reloadCreatePreparation, history);
}
